export enum CashPaymentStatus {
    NonCashPayment               = 0, // Nem készpénzes fizetés.
    CashPaymentPendingCollection = 1, // Beszedésre vár (Vásárlótól)
    CashPaymentCollected         = 2, // Beszedve (Vásárlótól)
    CashPaymentInProgress        = 3, // Befizetés folyamatban (PaySafe)
    CashPaymentCompleted         = 4, // Befizetés kész (PaySafe)
}
